import * as profileTypes from './profileTypes';

const initialState = {
  dynamicContent: {},
  name: '',
  initials: '',
  isLoading: false,
  relatedTabs: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case profileTypes.GET_PROFILE_NAME_SUCCESS:
      return {
        ...state,
        initials: action.payload.initials,
        name: action.payload.name,
      };

    case profileTypes.GET_PROFILE_DETAIL_SUCCESS:
      return {
        ...state,
        dynamicContent: {
          pageElements: action.payload.pageElements,
          lookUps: action.payload.lookUps,
        },
        relatedTabs: action.payload.relatedTabs,
      };

    case profileTypes.LOADING_PROFILE: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }

    default:
      return state;
  }
};
